module.exports = __webpack_public_path__ + "img/banner.d226a847.jpg";